import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiArrowUpRight, FiMessageCircle, FiPhone, FiGlobe } from 'react-icons/fi';

const Zakool = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section className="section-padding bg-navy text-white">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
        transition={{ duration: 0.6 }}
        className="container-custom"
      >
        <div className="max-w-5xl mx-auto">
          <p className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-4">Building Zakool AI</p>
          <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-10 lg:gap-16 items-start">
            <div>
              <h2 className="text-4xl md:text-5xl font-serif text-white mb-6">
                AI sales infrastructure for real estate developers and brokerages.
              </h2>
              <p className="text-lg text-gray-200 leading-relaxed mb-6">
                Zakool AI is designed to connect buyer journeys across web, WhatsApp and voice, so AI and human sales teams can work from a continuous understanding of the buyer instead of a series of disconnected interactions.
              </p>
              <p className="text-lg text-gray-200 leading-relaxed mb-8">
                We are building around property intelligence, buyer context, qualification, decision support and sales orchestration, with human teams stepping in where judgment, negotiation and relationships add the most value.
              </p>
              <a
                href="https://zakool.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-gold text-navy px-6 py-3 rounded-lg font-medium hover:bg-light-gold transition-colors"
              >
                Visit Zakool AI <FiArrowUpRight />
              </a>
            </div>

            <div className="grid grid-cols-1 gap-4">
              <div className="border border-white/15 rounded-xl p-5 bg-white/5">
                <FiGlobe className="text-gold text-2xl mb-3" />
                <h3 className="text-lg font-medium text-white mb-1">Web</h3>
                <p className="text-sm text-gray-300">Contextual property conversations and buyer discovery.</p>
              </div>
              <div className="border border-white/15 rounded-xl p-5 bg-white/5">
                <FiMessageCircle className="text-gold text-2xl mb-3" />
                <h3 className="text-lg font-medium text-white mb-1">WhatsApp</h3>
                <p className="text-sm text-gray-300">Continuous buyer engagement on the channel real estate teams already use.</p>
              </div>
              <div className="border border-white/15 rounded-xl p-5 bg-white/5">
                <FiPhone className="text-gold text-2xl mb-3" />
                <h3 className="text-lg font-medium text-white mb-1">Voice</h3>
                <p className="text-sm text-gray-300">Conversational AI with structured handoff to human sales teams.</p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Zakool;
